/**
 * Labels for the shared STATUS_REASON_CODE vocabulary (backend `StatusReasonEnum`).
 *
 * Its own module because the control that uses it is a component file, and
 * react-refresh requires a component file to export only components.
 */
export const REASON_CODE_LABEL: Record<string, string> = {
  no_inventory: 'No inventory',
  price: 'Price',
  using_competitor: 'Using a competitor',
  relationship: 'Relationship',
  service_issue: 'Service issue',
  seasonal: 'Seasonal',
  wrong_contact: 'Wrong contact',
  other: 'Other',
};

/** The one status that needs a date before it can be saved. */
export const CALL_BACK_STATUS = 'Call back';
